module.exports = {
      id: "double-arrow-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "svg-sprite-a2aa2e5b3e3b70ea2fa34e79b698feaf.svg#double-arrow",
      toString: function () {
        return this.url;
      }
    }